/* @ngInject */
export function AccreditationController($log, NavigationService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        $log.debug('Accreditation::init');
        var navConfig = NavigationService.getNavConfig();
        ctrl.colorName = navConfig.colorName;
        ctrl.icon = navConfig.icon;
    };
}
